import type { MenuLink } from '../types';

export const professionalLinks: MenuLink[] = [
  { label: 'For professionals', path: 'professionals', corePage: true },
  { label: 'Partner directory', path: 'partners' },
];
